import React, { useEffect, useState } from 'react';
import { getSitemap } from '../services/sitemapService';

const Sitemap = () => {
  const [sitemap, setSitemap] = useState('');

  useEffect(() => {
    const fetchSitemap = async () => {
      const xml = await getSitemap();
      setSitemap(xml);
    };
    fetchSitemap();
  }, []);

  return (
    <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
      {sitemap}
    </pre>
  );
};

export default Sitemap;